/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Delivery_Sla_RateInputs */

const vi_report_delivery_sla_rate = /** @type {(inputs: Report_Delivery_Sla_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tỷ lệ vi phạm`)
};

/**

* @param {Report_Delivery_Sla_RateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_delivery_sla_rate = /** @type {((inputs?: Report_Delivery_Sla_RateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Delivery_Sla_RateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_delivery_sla_rate(inputs)
});